module.exports = __webpack_public_path__ + "static/img/sys_building.23eeaaaa.png";